// extracted by mini-css-extract-plugin
module.exports = {"filter-sorting-section":"FilterSorting_filter-sorting-section__huWm4"};